// extracted by css-extract-rspack-plugin
export default {"root":"LuMLqQMxCwMuso15","message":"x4A4X5nxdY8u2P2f","withoutImages":"FquTwAt1X8MYGBkP","list":"QPGxAjDoHM8zn5AA","measure":"kztPHyL3HIgzxh4u"};